/** @format */
import isPropValid from '@emotion/is-prop-valid';
import {
    Button,
    ButtonVariant,
} from '@mpb-com/feather/components/atoms/button';
import { useTranslation } from 'next-i18next';
import React, { FunctionComponent, ReactNode, useContext } from 'react';
import styled from 'styled-components';

import { ApplicationContext } from '@toucan/client/global/application';

import { styles } from './condition-modal-content.styles';

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- Legacy code: do not use as an example.
export interface ConditionModalContentProps {
    /**
     * Child elements
     */
    children?: ReactNode;

    /**
     * Selection ID for test purposes.
     */
    'data-testid'?: string;

    /**
     * Custom className
     */
    className?: string;
}

const StyledConditionModalContent = styled('div').withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})`
    ${styles}
`;

// eslint-disable-next-line @mpb-com/mpb/todo-requires-ticket -- Legacy code: do not use as an example.
/**
 * TODO: Check if the component is needed. Originally created as assumed
 * Condition modal list (<ul>) styling is unique and shouldn't be used for
 * all modal content
 */
export const ConditionModalContent: FunctionComponent<
    ConditionModalContentProps
> = ({ children, ...otherProps }: ConditionModalContentProps) => {
    const { t } = useTranslation();
    const { setModalVisible } = useContext(ApplicationContext);
    return (
        <StyledConditionModalContent {...otherProps}>
            {children}
            <div className="modal-button-container">
                <Button
                    variant={ButtonVariant.SECONDARY}
                    className="modal-button"
                    onClick={() => setModalVisible(false)}
                >
                    {t('Understood')}
                </Button>
            </div>
        </StyledConditionModalContent>
    );
};
